export default "__VITE_PUBLIC_ASSET__6363b9e0__"